var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-section" },
    [
      _c("div", { staticClass: "section-title" }, [_vm._v("审核信息")]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { "label-width": "120px" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "客服审核" } },
                    [
                      _c("el-input", {
                        attrs: {
                          value: _vm.auditOpinion,
                          type: "textarea",
                          rows: 3,
                          placeholder: "请填写您的审批意见",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.$emit("update:auditOpinion", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    "text-align": "center",
                    "padding-top": "10px",
                  },
                  attrs: { span: 24 },
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["admin", "customerService:audit"],
                          expression: "['admin','customerService:audit']",
                        },
                      ],
                      attrs: { type: "danger", loading: _vm.auditing },
                      on: { click: _vm.handleReject },
                    },
                    [_vm._v("驳回")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["admin", "customerService:audit"],
                          expression: "['admin','customerService:audit']",
                        },
                      ],
                      attrs: { type: "success", loading: _vm.auditing },
                      on: { click: _vm.handleApprove },
                    },
                    [_vm._v("同意")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }